// Supplier portal sign-in (Lane 1331). The server gives the same answer for an
// unknown email, a wrong password and a locked account; the page shows it.
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { PublicShell, AuthCard } from './PortalShell';
import { portalApi, getPortalToken, setPortalToken, PORTAL_HOME, PORTAL_FORGOT } from './portalApi';

export default function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  // Already signed in: go to the events. A token that is no longer valid is
  // cleared by the next signed-in request, which sends the browser back here.
  useEffect(() => {
    if (getPortalToken()) navigate(PORTAL_HOME, { replace: true });
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setSaving(true);
    try {
      const r = await portalApi.login(email.trim(), password);
      setPortalToken(r.token);
      navigate(PORTAL_HOME, { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <PublicShell>
      <AuthCard title="Sign in to the supplier portal" subtitle="Quote on RFPs from the buyers who invited you." onSubmit={submit}>
        <div className="srcp-field">
          <label className="srcp-label" htmlFor="srcp-login-email">Email</label>
          <input id="srcp-login-email" className="srcp-input" type="email" value={email} maxLength={255}
            autoComplete="email" onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div className="srcp-field">
          <span className="srcp-label-row">
            <label className="srcp-label" htmlFor="srcp-login-pw">Password</label>
            <Link className="srcp-link" to={PORTAL_FORGOT}>Forgot password?</Link>
          </span>
          <input id="srcp-login-pw" className="srcp-input" type="password" value={password} maxLength={200}
            autoComplete="current-password" onChange={(e) => setPassword(e.target.value)} />
        </div>
        {error && <div className="srcp-error" role="alert">{error}</div>}
        <button type="submit" className="srcp-btn srcp-btn--primary" disabled={saving || !email.trim() || !password}>
          {saving ? 'Signing in…' : 'Sign in'}
        </button>
        <div className="srcp-auth-foot">New here? Open the invitation link the buyer emailed you.</div>
      </AuthCard>
    </PublicShell>
  );
}
